import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RoutesConfig } from './configs/routes.config';
import { AuthGuard } from './guards/auth.guard';
import {MasterDataResolver} from './common/master-data.resolver';
import { CateringRequestComponent } from './pages/catering/component/catering-request/catering-request.component';
import { CateringDetailsComponent } from './pages/catering/component/catering-details/catering-details.component';
import { AccessDeniedComponent } from './common/access-denied/access-denied.component';

const routes: Routes = [{
  path: '',
  redirectTo: RoutesConfig.pages.findSpace,
  pathMatch: 'full'
}, {
  path: RoutesConfig.pages.findSpace,
  loadChildren: () => import('./pages/find-a-space/find-a-space.module').then(m => m.FindASpaceModule),
  // canActivate: [AuthGuard]
}, {
  path: RoutesConfig.pages.bookings,
  loadChildren: () => import('./pages/bookings/bookings.module').then(m => m.BookingsModule),
/*  canActivate: [MsalGuard, AuthGuard]*/
}, {
  path: RoutesConfig.pages.calendar,
  loadChildren: () => import('./pages/calendar/calendar.module').then(m => m.CalendarModule),
  // canActivate: [MsalGuard, AuthGuard]
  canActivate: [MasterDataResolver]
}, {
  path: RoutesConfig.pages.meetings,
  loadChildren: () => import('./pages/meetings/meetings.module').then(m => m.MeetingsModule),
  // canActivate: [MsalGuard, AuthGuard]
}, {
  path: RoutesConfig.pages.serviceOrders,
  loadChildren: () => import('./pages/service-orders/service-orders.module').then(m => m.ServiceOrdersModule),
  // canActivate: [MsalGuard, AuthGuard]
},
{
  path: RoutesConfig.pages.preferences,
  loadChildren: () => import('./pages/preferences/preferences.module').then(m => m.PreferencesModule),
  // canActivate: [MsalGuard, AuthGuard]
  },
  {
    path: 'AccessDenied',
    component: AccessDeniedComponent
  },
  // Wildcard route for any invalid url
  {
    path: '**',
    loadChildren: () => import('./pages/find-a-space/find-a-space.module').then(m => m.FindASpaceModule),
    // canActivate: [AuthGuard]
 },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
